import { ReportColumnNames } from '@spa/api';

import {ReportTableColumn, ReportTableConfigInterface, ReportTableGroupedColumn} from '../../../app/shared/components';

export const SummaryByDatesReportTableConfig = (visibleAccountColumn: boolean): ReportTableConfigInterface => {
    const config = {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Date',
                selector: ReportColumnNames.Date,
                sortIndex: 1
            }),
            new ReportTableColumn({
                label: '',
                selector: ReportColumnNames.AssetType,
                sortIndex: 2
            }),
            new ReportTableColumn({
                label: 'Accounts',
                selector: ReportColumnNames.Accounts,
                sortIndex: 3
            }),
            new ReportTableColumn({
                label: 'Orders',
                selector: ReportColumnNames.Orders,
                sortIndex: 4
            }),
            new ReportTableColumn({
                label: 'Fills',
                selector: ReportColumnNames.Fills,
                sortIndex: 5
            }),
            new ReportTableColumn({
                label: 'Qty',
                selector: ReportColumnNames.Qty,
                sortIndex: 6,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Gross',
                selector: ReportColumnNames.Gross,
                sortIndex: 7,
                shifted: true
            }),
            new ReportTableGroupedColumn({
               label: 'Trade Fees',
                selector: 'TradeFees',
               childColumns: [
                   new ReportTableColumn({
                       label: 'Comm',
                       selector: ReportColumnNames.COMM,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'Ecn Fee',
                       selector: ReportColumnNames.ECNFee,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'SEC',
                       selector: ReportColumnNames.SEC,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'TAF',
                       selector: ReportColumnNames.TAF,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'NSCC',
                       selector: ReportColumnNames.NSCC,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'CLR',
                       selector: ReportColumnNames.CLR,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'ORF',
                       selector: ReportColumnNames.ORF,
                       shifted: true

                   }),
                   new ReportTableColumn({
                       label: 'PTFPF',
                       selector: ReportColumnNames.PTFPF,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'EFTT',
                       selector: ReportColumnNames.EFTT,
                       shifted: true
                   }),
                   new ReportTableColumn({
                       label: 'CAT',
                       selector: ReportColumnNames.CAT,
                       shifted: true
                   })
               ],
                sortIndex: 8
            }),
            new ReportTableColumn({
                label: 'Net',
                selector: ReportColumnNames.Net,
                sortIndex: 9,
                shifted: true
            }),

            /**
             * Following sortIndexes starts +1,
             * due to dynamically created grouped column
             * for Adjustments Fees
             */

            new ReportTableColumn({
                label: 'Adj Net',
                selector: ReportColumnNames.AdjSum,
                sortIndex: 11,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'Transfers',
                selector: ReportColumnNames.Transfers,
                sortIndex: 12,
                shifted: true
            }),
            new ReportTableGroupedColumn({
                label: 'End Balance',
                selector: 'EndBalance',
                childColumns: [
                    new ReportTableColumn({
                        label: 'Cash',
                        selector: ReportColumnNames.Cash,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Unrealized',
                        selector: ReportColumnNames.Unrealized,
                        shifted: true
                    })
                ],
                sortIndex: 13
            })
        ],
        hiddenColumnIds: [],
        actionMenu: false,
        disableColumnsOptions: true
    };

    if (!visibleAccountColumn) {
        config.columns = config.columns.filter((column: ReportTableColumn | ReportTableGroupedColumn) => {
            return (column.selector !== ReportColumnNames.Accounts);
        });
    }

    return config;
};
